// extracted by mini-css-extract-plugin
export default {"select":"_1A-dtViU5eCRjuA9YOSOHJ","input":"_2N4pcaUMDHIWxUYBSIn4GW","inputContainer":"_3kYB35BZMFpMZ4irB3crBw","numberInputContainer":"rMDhZoM-n7JOu8kEU1nf7"};